import fetch from 'node-fetch'
import FormData from 'form-data'
import { useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

export const useFormService = (source, target, useRecaptcha = true) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const getRecaptchaToken = useCallback(
    async (action) => {
      if (!executeRecaptcha) {
        throw new Error('Execute recaptcha not yet available')
      }
      if (!action) {
        throw new Error('No Action for recaptcha')
      }

      const token = await executeRecaptcha(action)
      return token
    },
    [executeRecaptcha],
  )

  const handleFormSubmit = async (formData, file) => {
    if (!formData) {
      throw new Error('Empty formdata')
    }

    const formDataObj = new FormData()
    Object.keys(formData).forEach((key) => {
      formDataObj.append(key, formData[key])
    })
    if (file) formDataObj.append('document', file)
    if (useRecaptcha) {
      const recaptchaAction = (source || target).replaceAll('-', '_')
      const token = await getRecaptchaToken(recaptchaAction)
      formDataObj.append('g-recaptcha-token', token)
    }

    const response = await fetch(target, {
      method: 'POST',
      body: formDataObj,
    })
    return response
  }

  return { handleFormSubmit }
}
